import styled from 'styled-components';
import { DoqType, LilInfoDoq, LilInfoDoqProps } from '@ardoq/doq';
import { colors } from '@ardoq/design-tokens';

// Common functionality

const MessageText = styled.span`
  color: ${colors.textSubtle};
`;

const PrefabInfoDoq = ({ message, ...rest }: LilInfoDoqProps) => {
  return (
    <LilInfoDoq message={<MessageText>{message}</MessageText>} {...rest} />
  );
};

// English defaults sit before the prop spread so an explicit `title={undefined}` still suppresses the title (Pattern A: package owns no i18n bundle, consumers pass `title="…"`).

type PrefabProps = Omit<LilInfoDoqProps, 'doqType'>;

export const InitialInfoDoq = (props: PrefabProps) => (
  <PrefabInfoDoq
    data-testid="initial-info-doq"
    doqType={DoqType.DROPZONE_INITIAL}
    title="Drop your file here, or pick a file"
    {...props}
  />
);

export const DragOverInfoDoq = (props: PrefabProps) => (
  <PrefabInfoDoq
    data-testid="dragover-info-doq"
    doqType={DoqType.DROPZONE_DRAGOVER}
    title="Drop to upload"
    {...props}
  />
);

export const ProcessingInfoDoq = (props: PrefabProps) => (
  <PrefabInfoDoq
    data-testid="processing-info-doq"
    doqType={DoqType.DROPZONE_UPLOADING}
    title="Uploading..."
    {...props}
  />
);

export const InvalidInfoDoq = (props: PrefabProps) => (
  <PrefabInfoDoq
    data-testid="invalid-info-doq"
    doqType={DoqType.DROPZONE_INVALID}
    title="The file you've uploaded is invalid"
    {...props}
  />
);

export const ErrorInfoDoq = (props: PrefabProps) => (
  <PrefabInfoDoq
    data-testid="error-info-doq"
    doqType={DoqType.DROPZONE_ERROR}
    title="Something went wrong..."
    {...props}
  />
);

export const SuccessInfoDoq = (props: PrefabProps) => (
  <PrefabInfoDoq
    data-testid="success-info-doq"
    doqType={DoqType.DROPZONE_SUCCESS}
    title="Upload successful"
    {...props}
  />
);
